import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CostCtrComponent } from './cost-ctr.component';
import { DefinitionComponent } from './definition/definition.component';
import { FacultyRangeComponent } from './faculty-range/faculty-range.component';
import { CcfAlphaComponent } from './ccf-alpha/ccf-alpha.component';
import { FacultyBeginningWithResolver, CostCenterResolver, CostCenterFacultyRangeResolver } from './resolvers';
import { CcimprovementsComponent } from './ccf-improvements/ccf-improvements.component';
import { CcbuildingComponent } from './ccf-building/ccf-building.component';
import { CcotherComponent } from './ccf-other/ccf-other.component';

const routes: Routes = [
  { path: '', component: CostCtrComponent },
  { path: 'cctr-definition', component: DefinitionComponent },
  {
    path: 'ccfacranges',
    component: FacultyRangeComponent,
    data: { title: 'Cost Center: Faculty Ranges' },
    resolve: { ccfacRanges: CostCenterFacultyRangeResolver}
  },
  {
    path: 'faclist',
    component: CcfAlphaComponent,
    data: {range: 'faculty', showPrintAlert: false},
      resolve: { title: FacultyBeginningWithResolver, ccenters: CostCenterResolver, ccfacRanges: CostCenterFacultyRangeResolver },
  },
  {
    path: 'buildinglist',
    component: CcbuildingComponent,
      data: { title: 'Cost Center - Buildings Numeric List - IACT 6720', range: 'buildings', showPrintAlert: false },
    resolve: { ccenters: CostCenterResolver },
  },
  {
    path: 'improvements',
    component: CcimprovementsComponent,
      data: { title: 'Cost Center - Improvements Alphabetic List - IACTs 6710 & 6715', range: 'improvements', showPrintAlert: false },
    resolve: { ccenters: CostCenterResolver },
  },
  {
    path: 'other',
    component: CcotherComponent,
      data: { title: 'Cost Center - Other Numeric List', range: 'other', showPrintAlert: false },
    resolve: { ccenters: CostCenterResolver },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CostCtrRoutingModule {}
